var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 25L22.4444 21.4444M24.2222 16.1111C24.2222 17.9971 23.473 19.8058 22.1394 21.1394C20.8058 22.473 18.9971 23.2222 17.1111 23.2222C15.2251 23.2222 13.4164 22.473 12.0828 21.1394C10.7492 19.8058 10 17.9971 10 16.1111C10 14.2251 10.7492 12.4164 12.0828 11.0828C13.4164 9.7492 15.2251 9 17.1111 9C18.9971 9 20.8058 9.7492 22.1394 11.0828C23.473 12.4164 24.2222 14.2251 24.2222 16.1111Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCSearch);
export default __webpack_public_path__ + "static/media/c_search.330508ff2ec6b0f7085f8f9da8a383fc.svg";
export { ForwardRef as ReactComponent };